module.exports = __webpack_public_path__ + "img/JSPwellness.e335d160.jpg";